module.exports = __webpack_public_path__ + "handshake.0b665a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Upgrade/images/handshake.jpg
// module id = xZ00
// module chunks = 0